(() => {
 const form=document.querySelector('.flavor-add');if(!form)return;
 const key='browndog-box-draft';
 const read=()=>{const value=JSON.parse(sessionStorage.getItem(key)||'[]');if(!Array.isArray(value))throw Error();return new Map(value.filter(([id,q])=>/^\d+$/.test(String(id))&&Number.isInteger(q)&&q>0&&q<=99));};
 try{const n=[...read().values()].reduce((a,b)=>a+b,0);if(n)form.querySelector('[role=status]').textContent=`${n} pints already in your box. Add this flavor and keep building.`;}catch(e){}
 form.addEventListener('submit',event=>{
  event.preventDefault();if(!form.reportValidity())return;
  const id=form.elements.variant?.value || form.dataset.variant;
  const quantity=Number(form.elements.quantity.value);
  try{
   const box=read();const total=(box.get(id)||0)+quantity;
   if(total>99){form.querySelector('[role=status]').textContent='You can select up to 99 pints of one flavor. Adjust the quantity and try again.';return;}
   box.set(id,total);sessionStorage.setItem(key,JSON.stringify([...box]));
   window.location.assign(form.dataset.builder);
  }catch(e){form.querySelector('[role=status]').textContent='Your browser could not save your selection. Return to the box builder and add this flavor there.';}
 });
})();
